type RouterQuery = Record<string, string | string[] | undefined>;

/** Build `?type=…&id=…` — omit null/undefined values. */
export function buildReconQueryString(params: {
  type?: string | null;
  id?: string | null;
}): string {
  const parts: string[] = [];
  if (params.type) parts.push(`type=${encodeURIComponent(params.type)}`);
  if (params.id) parts.push(`id=${encodeURIComponent(params.id)}`);
  return parts.length ? `?${parts.join("&")}` : "";
}

/** Read recon query params from Next.js router.query. */
export function getReconQueryParamsFromRouter(query: RouterQuery) {
  return {
    type: typeof query.type === "string" ? query.type : null,
    id: typeof query.id === "string" ? query.id : null,
  };
}

/** `?type=…&id=…` from the current route query (parse + format in one step). */
export function getReconQueryStringFromRouter(query: RouterQuery): string {
  const reconQuery = getReconQueryParamsFromRouter(query);
  return buildReconQueryString(reconQuery);
}

/** Append recon query params to a breadcrumb path (`/recon` gets type only). */
export function appendReconQueryToBreadcrumbPath(
  path: string,
  query: RouterQuery
): string {
  const { type, id } = getReconQueryParamsFromRouter(query);
  if (!type && !id) return path;
  return `${path}${buildReconQueryString({
    type,
    id: path === "/recon" ? null : id,
  })}`;
}
